import React from 'react';
import PropTypes from 'prop-types';
import ReactEChartsCore from 'echarts-for-react/lib/core';

import echarts from './echartsSetup';

function EChart({
  option,
  style,
  onEvents,
  onChartReady,
}) {
  return (
    <ReactEChartsCore
      echarts={echarts}
      option={option}
      notMerge
      style={style}
      onEvents={onEvents}
      onChartReady={onChartReady}
    />
  );
}

/* eslint-disable react/forbid-prop-types */
EChart.propTypes = {
  option: PropTypes.object,
  style: PropTypes.object,
  onEvents: PropTypes.object,
  onChartReady: PropTypes.func,
};

EChart.defaultProps = {
  option: {},
  style: { width: '100%', height: '100%' },
  onEvents: {},
  onChartReady: undefined,
};

export default EChart;
